export enum StepType {
	RegisterChild = "RegisterChild",
	ConfigureChild = "ConfigureChild",
	RegisterParent = "RegisterParent",
	BuyMembership = "BuyMembership",
}
